import { component, prop } from '../../../decorators';

@component
export default class Lookup {
   @prop({ type: Object, required: true }) info
   @prop({ type: Boolean, default: true }) ellipsis

   get name() {
      return this.info.name;
   }

   get desc() {
      const { talent, talentName } = this.info;
      return talent || talentName || null;
   }
}
